<section class="page__header">
 <custom-app-bar
         [title]="'language_selector.title' | translate"
         [hasBackButton]="true"
         [hasSaveButton]="!((isSideSheet$ | async) ?? false)"
         (onClickSaveButton)="saveSelectionAndExit()"
 ></custom-app-bar>
</section>
<section class="page__content">
 <div class="language-list">
  <div
          class="language-list__item"
          *ngFor="let language of languages"
  >
   <span>{{language.label}}</span>
   <custom-checkbox [checked]="(selectedLanguageCode$ | async) === language.code" (click)="$event.preventDefault();$event.stopPropagation();selectLanguage(language.code)"></custom-checkbox>
  </div>
 </div>
</section>

<section class="page__footer">
 <button
         customButton
         size="large"
         expand="full"
         *ngIf="isSideSheet$ | async"
         (click)="saveSelectionAndExit()"
 >
  {{ 'language_selector.accept' | translate}}
 </button>
</section>
